import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useDataProvider, useNotify } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import { SERVICE_TYPE_FILTERS } from '../../../constants/elevation';
import Spinner from '../../../Components/Spinner';
import { PrivateElevationDialog } from '../../Elevation/Components/PrivateElevationDialog';
import Button from '../../../Components/Buttons/CustomButton';
import { track } from '../../../analytics';
import MetricCardsSection from './MetricCardsSection';

const useStylesCustom = makeStyles(theme => ({
    button: {
        width: '180px',
    },
    pageHeading: {
        padding: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px 0`,
        justifyContent: 'left',
        alignItems: 'center',
        '& .MuiTypography-h4': {
            marginTop: theme.spacing(1),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            textAlign: 'center',
            justifyContent: 'space-around',
        },
    },
    buttonToElevation: {
        padding: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px 0`,
        justifyContent: 'left',
        alignItems: 'center',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            textAlign: 'center',
            justifyContent: 'space-around',
        },
    },
    contentWrapper: {
        position: 'relative',
        maxWidth: '1100px',
        alignSelf: 'center',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            padding: `0 0 0 ${theme.spacing(2)}px`,
        },
    },
    container: {
        justifyContent: 'center',
    },
}));

const PrivateModeElevationDashboardStats = ({ reviewAndFiCountData }) => {
    const dataProvider = useDataProvider()
    const classes = useStylesCustom()
    const notify = useNotify()

    const [primaryServiceTypeFetched, setPrimaryServiceTypeFetched] = useState(false)
    const [serviceType, setServiceType] = useState(null)

    const toDate = new Date()
    const fromDate = new Date()
    fromDate.setFullYear(fromDate.getFullYear() - 1)
    const [range] = useState(
        {
            from: fromDate,
            to: toDate
        }
    )

    const fetchPrimaryServiceType = () => {
        dataProvider('GET_ONE', 'elevation/primary-service-type')
            .then(res => {
                if (res.data.service_type_id) {
                    setServiceType(res.data.service_type_id)
                } else {
                    setServiceType(SERVICE_TYPE_FILTERS.find(item => item.type === 1).type)
                }
                setPrimaryServiceTypeFetched(true)
            })
            .catch((e) => {
                notify(e.message, 'warning')
            })
    }

    useEffect(()=> {
        fetchPrimaryServiceType()
    },[])

    const showPrivateElevationDialog = () => (
        reviewAndFiCountData < 5
    )

    return (
        <Grid container className={classes.container}>
            <div className={classes.contentWrapper}>
                <div className={classes.pageHeading}>
                    <Typography variant="h4" color={'primary'}>Explore your Elevation feedback</Typography>
                </div>
                {!primaryServiceTypeFetched && <Spinner />}
                {primaryServiceTypeFetched && serviceType &&
                    <MetricCardsSection serviceType={serviceType} range={range}/>
                }
                {primaryServiceTypeFetched && serviceType && showPrivateElevationDialog() &&
                    <PrivateElevationDialog />
                }
                <div className={classes.buttonToElevation}>
                    <Button
                        className={classes.button}
                        variant="outlined"
                        color="tertiary"
                        href={`/elevation-dashboard/v2`}
                        onClick={() => track('clicked_see_all_data_private_mode_dashboard', { category: 'DashboardV2' })}
                        disabled={showPrivateElevationDialog()}
                    >
                        See all data
                    </Button>
                </div>
            </div>
        </Grid>
    );
};

export default PrivateModeElevationDashboardStats
